import Vue from 'vue';
import Vuex from 'vuex';

import { apolloClient } from '@/apollo';
import { gql } from 'apollo-boost';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {
      id: 0,
      roles: [''],
      email: '',
      firstName: '',
      lastName: ''
    }
  },
  mutations: {
    saveUser(state, newUser) {
      state.user = { ...newUser };
    }
  },
  actions: {
    async getUser(context) {
      const { data }: any = await apolloClient.query({
        query: gql`
          {
            currentUser {
              id
              email
              roles
              firstName
              lastName
            }
          }
        `,
        fetchPolicy: 'network-only'
      });
      context.commit('saveUser', data.currentUser);
    }
  }
});
